<template>
  <div class="card shadow-sm">
    <div class="card-header py-1 px-2">
      <fa-icon icon="thermometer-half" /> temperature [°C]
    </div>
    <div class="card-body">
      <div class="chart-placehoder" id="temp-chart-placeholder">
        <canvas id="temp-chart-area" width="250" height="100"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from '@/lib/chart.js'
import { mapGetters } from 'vuex'

export default {
  name: 'temperature',
  data () {
    return {
      chart: null,
      config: {
        type: 'line',
        data: {
          datasets: [
            {
              data: [1, 1, 1, 1],
              fill: false,
              lineTension: 0,
              borderColor: 'rgb(36, 64, 107)'
            }
          ],
          yHighlightRange: [
            {
              begin: 0,
              end: 35,
              backgroundColor: 'rgba(143, 251, 175, 0.1)'
            },
            {
              begin: 35,
              end: 40,
              backgroundColor: 'rgba(255, 255, 102, 0.1)'
            },
            {
              begin: 40,
              end: 50,
              backgroundColor: 'rgba(219, 54, 69, 0.1)'
            }
          ]
        },
        options: {
          responsive: true,
          events: [],
          animation: false,
          elements: {
            point: {
              backgroundColor: 'rgb(36, 64, 107)'
            }
          },
          title: {
            display: false
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [
              {
                type: 'time',
                time: {
                  unit: 'second',
                  displayFormats: {
                    second: 'HH:mm:ss'
                  }
                }
              }
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  stepSize: 10,
                  min: 0,
                  max: 50
                }
              }
            ]
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['colors', 'history', 'thresh']),
    tempData () {
      return this.history.temp
    }
  },
  watch: {
    tempData () {
      this.chart.data.datasets[0].data = this.tempData
      this.chart.update()
    }
  },
  methods: {
    createChart () {
      const ctx = document.getElementById('temp-chart-area').getContext('2d')
      this.chart = new Chart(ctx, this.config)
    }
  },
  mounted () {
    this.createChart()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Temperature.vue